import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appDnd]',
})
export class DndDirective {
  @Output() fileDropped: EventEmitter<FileList> = new EventEmitter<FileList>();
  @HostBinding('class.file-over') fileOver: boolean = false;

  @HostListener('dragover', ['$event'])
  onDragOver(e: DragEvent) {
    this.toggle(e, true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(e: DragEvent) {
    this.toggle(e, false);
  }

  @HostListener('drop', ['$event'])
  ondrop(e: DragEvent) {
    this.toggle(e, false);
    let files = e.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileDropped.emit(files);
    }
  }

  private toggle(e: DragEvent, fileOver: boolean) {
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = fileOver;
  }
}
